module.exports = __webpack_public_path__ + "static/media/eliot.dccb9649.jpg";